<template>
    <div class="palette-wrapper">
        <h2>8-15每日基础复习案例：RGB颜色调色板</h2>

        <!-- 颜色预览区 -->
        <div class="color-preview" :style="{ backgroundColor: hexColor }" :title="hexColor"></div>

        <!-- 控制区 -->
        <div class="controls">
            <div class="slider-group">
                <label>R</label>
                <input type="range" min="0" max="255" v-model.number="rgb.r" class="slider slider--red" />
                <span>{{ rgb.r }}</span>
            </div>

            <div class="slider-group">
                <label>G</label>
                <input type="range" min="0" max="255" v-model.number="rgb.g" class="slider slider--green" />
                <span>{{ rgb.g }}</span>
            </div>

            <div class="slider-group">
                <label>B</label>
                <input type="range" min="0" max="255" v-model.number="rgb.b" class="slider slider--blue" />
                <span>{{ rgb.b }}</span>
            </div>
        </div>

        <!-- 色值展示 & 复制 -->
        <div class="color-info">
            <span class="hex">{{ hexColor }}</span>
            <button class="copy-btn" @click="copyHex">复制</button>
        </div>

        <!-- 常用色快捷按钮 -->
        <div class="preset-colors">
            <button v-for="color in presets" :key="color.hex" :style="{ backgroundColor: color.hex }"
                :title="color.name" @click="setColor(color.rgb)"></button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RGBColorPalette',
    data() {
        return {
            rgb: { r: 0, g: 0, b: 0 },
            presets: [
                { name: '红色', hex: '#ff0000', rgb: { r: 255, g: 0, b: 0 } },
                { name: '绿色', hex: '#00ff00', rgb: { r: 0, g: 255, b: 0 } },
                { name: '蓝色', hex: '#0000ff', rgb: { r: 0, g: 0, b: 255 } },
                { name: '天蓝', hex: '#87ceeb', rgb: { r: 135, g: 206, b: 235 } },
                { name: '橙色', hex: '#ffa500', rgb: { r: 255, g: 165, b: 0 } },
                { name: '紫色', hex: '#800080', rgb: { r: 128, g: 0, b: 128 } }
            ]
        };
    },
    computed: {
        // 切换十六进制颜色
        hexColor() {
            const { r, g, b } = this.rgb;
            return (
                '#' +
                [r, g, b]
                    .map(v => v.toString(16).padStart(2, '0'))
                    .join('')
                    .toUpperCase()
            );
        }
    },
    methods: {
        copyHex() {
            navigator.clipboard.writeText(this.hexColor).then(() => {
                alert('已复制：' + this.hexColor);
            });
        },
        setColor({ r, g, b }) {
            this.rgb = { r, g, b };
        }
    }
};
</script>

<style scoped>
h2 {
    font-size: 1.5rem;
    margin-bottom: 1.6rem;
    text-align: center;
    color: #333;
}

.palette-wrapper {
    max-width: 480px;
    margin: 40px auto;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    text-align: center;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.color-preview {
    width: 100%;
    height: 120px;
    border-radius: 8px;
    margin-bottom: 20px;
    transition: background-color 0.3s;
}

.controls {
    margin-bottom: 20px;
}

.slider-group {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
}

.slider-group label {
    width: 24px;
    font-weight: bold;
}

.slider {
    flex: 1;
    margin: 0 8px;
    cursor: pointer;
}

.slider--red {
    accent-color: #ff4d4f;
}

.slider--green {
    accent-color: #52c41a;
}

.slider--blue {
    accent-color: #1890ff;
}

.color-info {
    margin-bottom: 20px;
}

.hex {
    font-size: 1.2rem;
    font-weight: bold;
    margin-right: 12px;
}

.copy-btn {
    padding: 4px 12px;
    border: none;
    border-radius: 4px;
    background-color: #1890ff;
    color: #fff;
    cursor: pointer;
}

.copy-btn:hover {
    background-color: #40a9ff;
}

.preset-colors {
    display: flex;
    justify-content: center;
    gap: 8px;
}

.preset-colors button {
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    transition: transform 0.2s;
}

.preset-colors button:hover {
    transform: scale(1.1);
}
</style>